var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-file"},[_c('dropzone',{attrs:{"id":"file-dropzone","options":_vm.options},on:{"vdropzone-sending":_vm.UploadFile,"vdropzone-complete":_vm.HandleResponse}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }